import { postWithAuth, getWithAuth } from '../../../Basic/HttpService';
import { memoize } from 'lodash';

export const getChecksAddTabByID = async (id, checkID, ScheduleEventID, ScheduleID) => {
    let res = await getWithAuth(
        `VehicleInspection/AddScreenDetails?Id=${id}&DisplayCheck=${checkID}${ScheduleEventID ? '&ScheduleEventID=' + ScheduleEventID : ''}${
            ScheduleID ? '&ScheduleID=' + ScheduleID : ''
        }`
    );
    return res;
};
export const getTyreCheckData = async (vehicleID) => {
    let res = await getWithAuth(`VehicleInspection/VehicleInspections_GetPreviousAxles?VehicleID=${vehicleID}`);
    return res;
};

export const postChecksData = async (data) => {
    let res = await postWithAuth(`VehicleInspection`, data);
    return res;
};
export const postSignOffChecksData = async (data) => {
    let res = await postWithAuth(`VehicleInspection/VehicleInspections_SignOff`, data);
    return res;
};

export const getChecksEditByID = async (id, checkID) => {
    let res = await getWithAuth(`VehicleInspection/EditScreenDetails?Id=${id}&DisplayCheck=${checkID}`);
    return res;
};

export const getChecks = async (id) => {
    let res = await getWithAuth(`VehicleInspection/list`);
    return res;
};

export const getSingleChecks = async (id) => {
    let res = await getWithAuth(`VehicleInspection/DefectDetails?ResultID=${id}`);
    return res;
};

export const postSingleChecksData = async (data) => {
    let res = await postWithAuth(`VehicleInspection/DefectDetails `, data);
    return res;
};

export const PostImage = async (data) => {
    let res = await postWithAuth(`VehicleInspectionsPhoto`, data);
    return res;
};
export const getImageByID = async (id) => {
    let res = await getWithAuth(`VehicleInspectionsPhoto/${id}`);
    return res;
};
export const deleteImageByID = async (id) => {
    let res = await postWithAuth(`VehicleInspectionsPhoto/Delete/${id}`);
    return res;
};
export const VehicleInspections_ReturnToTech = async (data) => {
    let res = await postWithAuth(`VehicleInspection/VehicleInspections_ReturnToTech`, data);
    return res;
};

export const VehicleJobPart_Repocess_SendToSage = async (vehicleJobPartID) => {
    let res = await postWithAuth(`VehicleJobItems/VehicleJobPart_Repocess_SendToSage?vehicleJobPartID=${vehicleJobPartID}`, {});
    return res;
};

export const SalesInvoice_ReprocessToSage = async (InvoiceId) => {
    let res = await postWithAuth(`Invoices/SalesInvoice_ReprocessToSage?InvoiceId=${InvoiceId}`, {});
    return res;
};

export const getGenerateVehicleInspectionReportPdf = async (id, checkID) => {
    let res = await getWithAuth(`VehicleInspection/GenerateVehicleInspectionReport/${id}?DisplayCheck=${checkID}`);
    return res;
};

export const getVehicleContractByStatusXLSX = async (StatusID) => {
    let res = await getWithAuth(`VehicleContract?StatusID=${StatusID}&Filetype=${'excel'}`, {
        responseType: 'blob',
        returnOrgRes: true
    });

    return res;
};
